<template>
    <div>
        <navbar navbar-menu-classes="navbar-left">
          <div>
            <router-link class="navbar-brand" to="/">
                <img :src="logo" alt="Kobotrack" style="display: inline"> Kobotrack</router-link>
          </div>
        </navbar>
        
    </div>
</template>

<script>
  import {Navbar} from 'src/components/UIComponents'
  export default {
    name: 'main-navbar',
    components: {
      Navbar
    },
    props: {
      logo: {
        type: String,
        default: 'static/img/kobotrack-logo.png'
      },
    }
  }
</script>

<style scoped>

</style>
